var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.autocomplete.shown)?_c('AutoCompleteViewer',{staticClass:"the-map__autocompleteviewer",on:{"place_changed":_vm.setPlace}}):_vm._e(),_c('GmapMap',{ref:"mapRef",staticClass:"gmap-container",attrs:{"center":_vm.position,"zoom":_vm.zoom,"map-type-id":"hybrid","options":_vm.computedMapOptions}},[_c('GmapInfoWindow',{ref:"infoWindow",attrs:{"v-if":_vm.markerIndex !== -1,"position":_vm.infoView.position || _vm.markerPosition,"opened":_vm.infoView.status.active,"options":_vm.infoView.options ? _vm.infoView.options : {
        pixelOffset: {
          width: 0,
          height: -50
        }
      }},on:{"closeclick":_vm.closeInfoWindow}},[_c('info-view',{attrs:{"title":_vm.infoView.title,"link":_vm.infoView.link,"subtitle":_vm.infoView.subtitle,"subtitle2":_vm.infoView.subtitle2,"empty-response":_vm.infoView.emptyResponse,"date":_vm.infoView.date,"data":_vm.infoView.data,"chart-options":_vm.infoView.chartOptions}})],1),_vm._l((_vm.markers),function(m,index){return _c('GmapMarker',{key:index,attrs:{"label":m.label ? {
        text: m.label,
        fontWeight: 'bold'
      } : '',"icon":m.type === 'circle' ? {
        path: _vm.google.maps.SymbolPath.CIRCLE,
        scale: 14.5,
        fillColor: m.color,
        fillOpacity: 0.4,
        strokeColor: '#000000',
        strokeOpacity: 0.8,
        strokeWeight: 1.5,
      } : {
        url: _vm.markerID === m.id ? _vm.getIconMarker('green') : _vm.getIconMarker(m.color), // url
        scaledSize: new _vm.google.maps.Size(32, 41), // scaled size
        origin: new _vm.google.maps.Point(0, 0), // origin
        anchor: new _vm.google.maps.Point(16, 50) // anchor
      },"position":m.position,"clickable":true},on:{"click":function($event){return _vm.selectMarker({ marker: m, index: index })}}})}),_c('GroundOverlayViewer',{attrs:{"overlays":_vm.groundOverlays}}),_c('GmapOverlayViewer',{attrs:{"overlays":_vm.overlays}})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }